import { clx } from "@hm/fundamental"

interface ContainerBoxProps {
	children?: React.ReactNode
	"data-cy"?: string
	className?: string
	withBottomMargin?: boolean
}

export const ContainerBox: React.FC<ContainerBoxProps> = ({
	children,
	"data-cy": dataCy,
	className,
	withBottomMargin = false,
}: ContainerBoxProps) => {
	return (
		<div
			data-cy={dataCy}
			className={clx(
				"px-2 md:px-6",
				withBottomMargin && "mb-6",
				className,
			)}
		>
			{children}
		</div>
	)
}
